import { Playground } from 'docz';
import { Container, Section } from "../../../../../src/components/Layout";
import Icons from "../../../../../src/components/Icons";
import * as React from 'react';
export default {
  Playground,
  Container,
  Section,
  Icons,
  React
};